type Props = {
  enableAutoLoad: boolean;
  remainingAttempts: number;
  pending: boolean;
  hasDates: boolean;
};

export function shouldAdvanceAutoLoad(props: Props): boolean {
  const { enableAutoLoad, remainingAttempts, pending, hasDates } = props;
  if (!enableAutoLoad) return false;
  if (remainingAttempts <= 0) return false;
  if (pending) return false;
  if (hasDates) return false;
  return true;
}
